import { render } from "./Navigationbar.vue?vue&type=template&id=470ca96f"
import script from "./Navigationbar.vue?vue&type=script&lang=js"
export * from "./Navigationbar.vue?vue&type=script&lang=js"

import "./Navigationbar.vue?vue&type=style&index=0&id=470ca96f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__